import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminApprovalsComponent } from './admin-approvals.component';

const routes: Routes = [
  {
    path: '', component: AdminApprovalsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminApprovalsRoutingModule { }
